const items = [
  { title: "100% Guaranteed", sub: "Stand behind every weld & pipe" },
  { title: "EPA Certified", sub: "Licensed HVAC refrigerant care" },
  { title: "Care for Property", sub: "Drop cloths & spotless clean-up" },
  { title: "Better Rates", sub: "Transparent pricing structure" },
];

export default function Guarantees() {
  return (
    <section className="border-y border-[#3A4752] bg-[#1B2229] py-6" data-testid="guarantee-bar">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 grid grid-cols-2 md:grid-cols-4 gap-6 text-center">
        {items.map((it, i) => (
          <div key={it.title} className={`p-2 ${i > 0 ? "md:border-l border-[#DCD3C9]" : ""}`} data-testid={`guarantee-${i}`}>
            <div className="font-bold text-xl text-[#1E252B]">{it.title}</div>
            <div className="text-xs text-[#736B63] mt-1">{it.sub}</div>
          </div>
        ))}
      </div>
    </section>
  );
}
